<template lang="pug">
  .social-login
    .social-links
      .field(v-if="social.google")
        .field-body.has-icon.icon-black
          button.main-btn.bg-transparent.google(
          @click="toSocial(social.google, params)"
          :disabled="disabled")
            | {{ gettext('Use Google account') }}
            img(src="/webapp/images/icons/google.svg")
      .field(v-if="social.facebook")
        .field-body.has-icon.icon-black
          button.main-btn.bg-transparent.facebook(
          @click="toSocial(social.facebook, params)"
          :disabled="disabled")
            | {{ gettext('Use Facebook account') }}
            i.mdi.mdi-facebook
      .field(v-if="socialHasError()")
        .field-body.error-field
          .notification.is-warning
            .mdi.mdi-information-outline.mdi-24px &nbsp;
              | {{ socialError.message }}
      .field(v-if="socialHasError() && socialError.error_code === '30'")
        .field-body.link-field.margined
          | {{ gettext('Deleted your account?') }} &nbsp;
          router-link.link-red(:to="{name: 'RestoreAccount', params: {lang: getLanguage}, query: {is_social: true}}") {{ gettext('Restore it') }}

</template>
<script>
import { SocialMixin } from '@/mixins/SocialMixin'
import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'

export default {
  name: 'SocialLogin',
  mixins: [
    SocialMixin
  ],
  props: {
    social: {
      default: () => {
        return {}
      }
    },
    nextError: {
      default: ''
    },
    nextLogin: {
      default: ''
    },
    nextSignup: {
      default: ''
    },
    disabled: {
      default: false
    }
  },
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    params () {
      return {
        next_err: this.nextError,
        next_login: this.nextLogin,
        next_signup: this.nextSignup,
        lang: this.getLanguage,
        jwt_aud: 'webapp'
      }
    }
  }
}
</script>
<style lang="scss">
  .social-login {
    .social-links {
      .notification {
        width: 100%;
        border-radius: 0;
      }
      .field {
        .field-body {
          width: 100%;
          .facebook{
            background-color: #4267b2;
            color: #fff;
            i{
              color: #fff;
            }
          }
          .main-btn{
            padding-left: 40px;
            line-height: normal;
          }
          .google{
            img{
              position: absolute;
              width: 20px;
              left: 15px;
              top: 50%;
              transform: translate(0, -50%);
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/social-login/index.vue